export const firebaseConfig = {
  apiKey: process.env.NX_FIREBASE_API_KEY,
  appId: process.env.NX_FIREBASE_APP_ID,
  authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NX_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.NX_FIREBASE_MESSAGING_SENDER_ID || process.env.NX_FIREBASE_MESSAGE_SENDER_ID,
  projectId: process.env.NX_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET
};
